<template>
    <section class="custom_quote_section2">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="container">
            <h3 class="get-cash">How It Works</h3>
            <div class="row position-relative">
                <div class="col-md-4" v-for="(row, index) in bodyData" :key="index">
                    <div class="d-flex flex-row bd-highlight mb-3">
                        <div class="col-md-10 mb-md-0 same-height" style="min-height: 273px;">
                            <div class="img">
                                <img :src="imagePath + row.image" alt="Avatar">
                            </div>
                            <h3><strong>{{ index+1 }}.</strong> {{ row.title }} </h3>
                            <p v-html="row.detail"></p>
                        </div>
                        <div v-if="index < bodyData.length-1" class="col-md-2 position-static p-4 d-none d-md-none d-lg-block" style="margin-top: 5.5rem;">
                            <div><i class="fa fa-arrow-right" style="font-size: 3rem; color: #555;"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "QuoteBody",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            bodyData: [],
            imagePath: this.$api + "upload/quote/"
        }
    },
    created() {
        document.title = "Geek Buy Back - Custom Quote";
        this.getBodyData();
    },
    methods: {
        getBodyData: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + this.$config.customQuote.getBodyDataURL
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.bodyData = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        }
    }
}
</script>

<style scoped>
.cls-1 {
    fill: none;
    stroke: #02B514;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: .71px
}
.cls-1, .cls-2 {
    fill: none;
    stroke: #02B514;
    stroke-linecap: round
}
.cls-1 {
    stroke-linejoin: round
}
.cls-2 {
    stroke-miterlimit: 10
}
</style>
